import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { usePosts } from '../../contexts/PostContextProvider'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import '../../styles/PostDetails.css'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import { useBasket } from '../../contexts/BasketContextProvider'

const PostDetails = () => {
	const { id } = useParams()

	const { getOnePost, onePost, onePostClear } = usePosts()
	const { addPostToBasket } = useBasket()
	// setTimeout(function () {
	// 	useEffect(() => {
	// 		getOnePost(id)
	// 	}, [])
	// }, 1000)

	useEffect(() => {
		setTimeout(() => {
			getOnePost(id)
		}, 2000)
		return () => {
			onePostClear()
		}
	}, [])

	function handelAddBasket() {
		console.log('hello')
		addPostToBasket(onePost)
	}

	return (
		<div className='post-detail'>
			{onePost ? (
				<article className='t'>
					<header className='card__thumb'>
						<a href='#'>
							<img
								src={`https://nft-server-cyberpunk.onrender.com${onePost.attributes.image.data.attributes.url}`}
								width='100%'
								height='250px'
							/>
						</a>
					</header>

					<div className='card__body'>
						<div className='card__category'>
							<p>{onePost.attributes.author}</p>
						</div>
						<h2 className='card__title' style={{ color: 'white' }}>
							<div href='#'>{onePost.attributes.title}</div>
						</h2>
						<p className='card__description'>
							{onePost.attributes.description}
						</p>
					</div>

					<footer className='card__footer'>
						<div className='btn btn--primary'>
							<button onClick={handelAddBasket} className='btn__container'>
								Add to basket
							</button>
							<div className='btn__bottom'></div>
						</div>
					</footer>
				</article>
			) : (
				<div className='preloader' style={{ marginTop: '13vw', color: 'aqua' }}>
					<div className='preloader__ring'>
						<div className='preloader__sector'>L</div>
						<div className='preloader__sector'>o</div>
						<div className='preloader__sector'>a</div>
						<div className='preloader__sector'>d</div>
						<div className='preloader__sector'>i</div>
						<div className='preloader__sector'>n</div>
						<div className='preloader__sector'>g</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
					</div>
					<div className='preloader__ring'>
						<div className='preloader__sector'>L</div>
						<div className='preloader__sector'>o</div>
						<div className='preloader__sector'>a</div>
						<div className='preloader__sector'>d</div>
						<div className='preloader__sector'>i</div>
						<div className='preloader__sector'>n</div>
						<div className='preloader__sector'>g</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'>.</div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
						<div className='preloader__sector'></div>
					</div>
				</div>
			)}
		</div>
	)
}

export default PostDetails
